import { Fragment } from 'react';
import { Divider, Heading, Paragraph } from '@zillow/constellation';
import type { Answers } from '../../../../../graphql/queries';
import { getAnswersForFields } from '../../../../../utils/overview/overview-display';
import { FIELD_IDS } from '../../../../../constants/wizard';
import { get } from 'lodash-es';
import { formatDate, getPhoneNumberScreenFormat } from '../../../../../utils/formatters';

interface Props {
  answers: Answers;
}

const fieldsInStep = [
  FIELD_IDS.PAST_JOBS_TITLE,
  FIELD_IDS.PAST_JOBS_ORGANIZATION,
  FIELD_IDS.PAST_JOBS_START_DATE,
  FIELD_IDS.PAST_JOBS_END_DATE,
  FIELD_IDS.PAST_JOBS_EMPLOYER_NAME,
  FIELD_IDS.PAST_JOBS_EMPLOYER_EMAIL,
  FIELD_IDS.PAST_JOBS_EMPLOYER_PHONE,
];

export function PastJobsOverview({ answers }: Props) {
  const answersForFields = getAnswersForFields({ fieldIds: fieldsInStep, answers }) as { [key: string]: Array<string> };

  const { pastJobs } = answers;

  return (
    <>
      {pastJobs &&
        pastJobs.map((pastJob, index) => {
          const title = get(answersForFields[FIELD_IDS.PAST_JOBS_TITLE], `[${index}]`);
          const organization = get(answersForFields[FIELD_IDS.PAST_JOBS_ORGANIZATION], `[${index}]`);
          const startDate = get(answersForFields[FIELD_IDS.PAST_JOBS_START_DATE], `[${index}]`);
          const endDate = get(answersForFields[FIELD_IDS.PAST_JOBS_END_DATE], `[${index}]`);
          const employerName = get(answersForFields[FIELD_IDS.PAST_JOBS_EMPLOYER_NAME], `[${index}]`);
          const employerEmail = get(answersForFields[FIELD_IDS.PAST_JOBS_EMPLOYER_EMAIL], `[${index}]`);
          const employerPhone = get(answersForFields[FIELD_IDS.PAST_JOBS_EMPLOYER_PHONE], `[${index}]`);

          return (
            <Fragment key={pastJob?.id ?? index}>
              {index !== 0 && <Divider marginY="md" />}
              <Heading level={6} as="h5" marginY="xs" fontColor="textMedium">
                Past job #{index + 1}
              </Heading>
              {title && (
                <>
                  <Heading level={6} marginY="xs">
                    Job title
                  </Heading>
                  <Paragraph>{title}</Paragraph>
                </>
              )}
              {organization && (
                <>
                  <Heading level={6} marginY="xs">
                    Employer
                  </Heading>
                  <Paragraph>{organization}</Paragraph>
                </>
              )}
              {startDate && (
                <>
                  <Heading level={6} marginY="xs">
                    Started on
                  </Heading>
                  <Paragraph>{formatDate(startDate)}</Paragraph>
                </>
              )}
              {endDate && (
                <>
                  <Heading level={6} marginY="xs">
                    Ended on
                  </Heading>
                  <Paragraph>{formatDate(endDate)}</Paragraph>
                </>
              )}
              {(employerName || employerEmail || employerPhone) && (
                <>
                  <Heading level={6} marginY="xs">
                    Employer contact info
                  </Heading>
                  {employerName && <Paragraph>{employerName}</Paragraph>}
                  {employerEmail && <Paragraph>{employerEmail}</Paragraph>}
                  {employerPhone && <Paragraph>{getPhoneNumberScreenFormat(employerPhone)}</Paragraph>}
                </>
              )}
            </Fragment>
          );
        })}
    </>
  );
}
